module.exports = __webpack_public_path__ + "static/img/dress.04ea47a8.jpg";